'use strict';
require('../../modules/esnext.observable');
require('../../modules/esnext.symbol.observable');
require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/web.dom-collections.iterator');
var path = require('../../internals/path');

module.exports = path.Observable;
